import { Box, Button, Card, CardContent, Chip, CircularProgress, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Loading from '../../../components/Loader/Loading';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../../components/pagination/CustomPagination';
import { useForm, Controller } from 'react-hook-form';
import { FormControl, InputAdornment, IconButton, MenuItem, Select, TextField } from '@mui/material';
import { ArrowBack, Clear, Download, Search } from '@mui/icons-material';
import dayjs from 'dayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ExportAll from './ExportAll'
import { ReportServices } from '../ReportServices';
import FinalPayout from './FinalPayout';
import { useDispatch } from 'react-redux';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';

const getLastWeekRange = () => {
    const today = dayjs();
    const daysToThisMonday = (today.day() + 6) % 7;
    const thisMonday = today.subtract(daysToThisMonday, 'day');
    const lastMonday = thisMonday.subtract(7, 'day');
    const lastSunday = thisMonday.subtract(1, 'day');
    return {
        startDate: lastMonday.format('YYYY-MM-DD'),
        endDate: lastSunday.format('YYYY-MM-DD'),
    };
};

const ExpertPayout = (props) => {
    const { } = props;
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'expert-payout-report'
        });
    }, []);

    const {control,watch,handleSubmit,setValue, formState: { isDirty }} = useForm({
        defaultValues: getLastWeekRange()
    });
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [finalPayout, setFinalPayout] = useState(null);
    const columns=[
        { field: 'bookingNumber', sortable:false ,headerName: 'Booking No.', width: 180, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Booking No.</span>,
            renderCell: (params) =>(
                <Typography color="primary" sx={{fontSize:'.65rem',cursor:'pointer'}} >
                    {params.value}
                    {/* {' '} */}
                    {/* {params.row.customerId == params.row.createdBy && <PhoneAndroid sx={{fontSize:'.65rem'}} color='warning'/>} */}
                </Typography>
            )
        },
        
        {
            field: 'subTotal', sortable:false ,headerName: 'Sub Total', width: 150, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Sub Total</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        {
            field: 'discount', sortable:false ,headerName: 'Discount', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Discount</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )

        },
        {
            field: 'coinValue', sortable:false ,headerName: 'Coin Value', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Coin Value</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )

        },
        {
            field: 'couponAmount', sortable:false ,headerName: 'Coupon Amount', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Coupon Amount</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )

        },
        {
            field: 'platformCharges', sortable:false ,headerName: 'Platform Charges', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Platform Charges</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )

        },
        {
            field: 'convenienceFee', sortable:false ,headerName: 'Convenience Fee', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Convenience Fee</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )

        },
        {
            field: 'VisitingCharge', sortable:false ,headerName: 'Visiting Charge', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Visiting Charge</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )

        },
        { field: 'tax', sortable:false ,headerName: 'tax', width: 150, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>tax</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'total', sortable:false ,headerName: 'total', width: 120, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>total</span> ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'serviceDate', sortable:false ,headerName: 'serviceDate', width: 110, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>serviceDate</span>,
            // valueFormatter: (params) => ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'bookingStatus', sortable:false ,headerName: 'bookingStatus', width: 160, headerAlign: 'left', align: 'left',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>bookingStatus</span> ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'expertName', sortable:false ,headerName: 'Expert Name', width: 60, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Expert Name</span> ,
            renderCell: (params) => (
                <Box sx={{ display: 'flex',alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'expertId', sortable:false ,headerName: 'Expert Id', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Expert Id</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'total_discount', sortable:false ,headerName: 'Total Discount (₹)', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Total Discount (₹)</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'netBase', sortable:false ,headerName: 'Net Base (₹)', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Net Base (₹)</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'ExpertPlatformBaseFee', sortable:false ,headerName: 'Expert Platform Fee (Base) (₹)', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Expert Platform Fee (Base) (₹)</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'GSTonPlatformFee', sortable:false ,headerName: 'GST on Platform Fee (18%) (₹)', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>GST on Platform Fee (18%) (₹)</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'ExpertPlatformFeeWithGST', sortable:false ,headerName: 'Expert Platform Fee + GST (₹)', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Expert Platform Fee + GST (₹)</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'tip', sortable:false ,headerName: 'Tip (₹)', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Tip (₹)</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'Adjustment', sortable:false ,headerName: 'Adjustment (₹)', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Adjustment (₹)</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'TCS', sortable:false ,headerName: 'TCS (₹)', width: 90, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>TCS (₹)</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{(parseFloat(params.row?.coinDiscount || 0) + parseFloat(params.row?.couponDiscount || 0)).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'payableAmount', sortable:false ,headerName: 'Payable Amount (₹)', width: 100, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Payable Amount (₹)</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'Status', sortable:false ,headerName: 'Status', width: 80, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Status</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                <Chip label={params.value} color={params.value == 'Sent for payout' ? 'success' : 'error'} size='small' sx={{fontSize:'.75rem',textTransform:'capitalize'}} />
                </Box>
            )
        },
        { field: 'Remarks', sortable:false ,headerName: 'Remarks', width: 80, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Remarks</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            ) 
        },
        { field: 'PayoutCyleDate', sortable:false ,headerName: 'Payout Cyle Date', width: 80, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Payout Cyle Date</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>{params.value}</Typography>
                </Box>
            )
        },
        { field: 'PaidByCustomer', sortable:false ,headerName: 'Paid By Customer', width: 95, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Paid By Customer</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'DiffAmountPayablevsByCust', sortable:false ,headerName: 'Diff Amount-Payable vs By Cust', width: 100, headerAlign: 'center', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Diff Amount-Payable vs By Cust</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
        { field: 'CudelEarning', sortable:false ,headerName: 'Cudel Earning', width: 60, headerAlign: 'right', align: 'right',
            renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Cudel Earning</span>,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems:"right",justifyContent:'right', width:'100%' }}>
                    <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                </Box>
            )
        },
    ]
    
    const startDate = watch('startDate');
    const endDate = watch('endDate');
    const handleClear = () => {
        const { startDate: defaultStart, endDate: defaultEnd } = getLastWeekRange();
        setValue('startDate', defaultStart);
        setValue('endDate', defaultEnd);
        setRows([]);
        setFinalPayout(null);
        fetchPayoutRecords();
    }
    const submitHandler = (data) => {
        // fetchPayoutRecords();
        console.log(data);
        fetchPayoutRecords();
    }
    const fetchPayoutRecords = async () => {
        console.log('Fetching payout records with:', { startDate, endDate });
        // return;
        setLoading(true);
        setRows([]);
        setFinalPayout(null);

        try {
            let response;
            if (startDate && endDate) {
                response = await ReportServices.fetchExpertPayoutRecords({
                    startDate,
                    endDate
                });
            }

            if (response?.success === 1) {
                if (response.data.rows) {
                    setRows(response.data.rows);
                }
                if (response.data.payout_records) {
                    setFinalPayout(response.data.payout_records);
                }
            }
        } catch (error) {
            console.error('Error fetching tax data:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchPayoutRecords();
    }, []);
  return (
    <>
        <PageHeaderLayout headerTitle="Expert Payout Report" >
            <Button variant='contained' onClick={() => window.history.back()} size='small' endIcon={<ArrowBack />}>
                Back
            </Button>
        </PageHeaderLayout>
        <Card>
            <Box sx={{ overflow: "auto" }}>
                <Box 
                    sx={{ 
                    width: "100%", display: "table",  tableLayout: "fixed", 
                    backgroundColor: "#fff", borderRadius: '.5rem',
                    '& .odd': {
                        bgcolor: 'white',
                    },
                    '& .even': {
                        bgcolor: '#ECECEC',
                    },
                }}>
    
            {loading && <Loading/>}
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between',alignItems:'center',p:'1%' }}>
                
                    <Box component={'form'} onSubmit={handleSubmit(submitHandler)} flex={1}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <Controller
                                    name="startDate"
                                    control={control}
                                    rules={{
                                        // validate: (value) => {
                                        // if (!value) return "This field is required";
                                        // const date = dayjs(value);
                                        // const today = dayjs().startOf('day');
                                        // return date.isValid() && (date.isSame(today, 'day') || date.isAfter(today)) || "Booking Date must be today or in the future";
                                        // }
                                    }}
                                    render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                {...restField}
                                                sx={{
                                                '& . iconButton': {
                                                    padding: 0.5,
                                                    fontSize: '1rem'
                                                }
                                                }}
                                                label="Start Date"
                                                // disabled={!watch('services').length>0 || !watch('customer')}
                                                value={value ? dayjs(value) : null}
                                                onChange={(newValue) => {
                                                // Store the date in YYYY-MM-DD format for database compatibility
                                                onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                                                }}
                                                format="DD-MM-YYYY" // Display format for user
                                                // minDate={dayjs()}
                                                maxDate={dayjs(watch('endDate'))}
                                                slotProps={{
                                                textField: {
                                                    error: !!error,
                                                    helperText: error?.message,
                                                    fullWidth: true,
                                                    required: true,
                                                    size: 'small',
                                                    inputProps: {
                                                    style: { fontSize: '.75rem' }
                                                    }
                                                }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                {/* <DatePicker
                                    label="End Date"
                                    value={endDate}
                                    onChange={(newValue) => setEndDate(newValue)}
                                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                    minDate={startDate}
                                    maxDate={dayjs()}
                                /> */}
                                <Controller
                                    name="endDate"
                                    control={control}
                                    rules={{
                                        // validate: (value) => {
                                        // if (!value) return "This field is required";
                                        // const date = dayjs(value);
                                        // const today = dayjs().startOf('day');
                                        // const start = dayjs(watch('startDate'));
                                        // if (!date.isValid()) return "Invalid date";
                                        // if (date.isBefore(start)) return "End Date cannot be before Start Date";
                                        // // if (date.isAfter(today)) return "End Date cannot be in the future";
                                        // return true;
                                        // }
                                    }}
                                    render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                {...restField}
                                                sx={{
                                                '& . iconButton': {
                                                    padding: 0.5,
                                                    fontSize: '1rem'
                                                }
                                                }}
                                                label="End Date"
                                                // disabled={!watch('services').length>0 || !watch('customer')}
                                                value={value ? dayjs(value) : null}
                                                onChange={(newValue) => {
                                                // Store the date in YYYY-MM-DD format for database compatibility
                                                onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
                                                }}
                                                format="DD-MM-YYYY" // Display format for user
                                                minDate={dayjs(watch('startDate'))}
                                                // maxDate={dayjs()}
                                                slotProps={{
                                                textField: {
                                                    error: !!error,
                                                    helperText: error?.message,
                                                    fullWidth: true,
                                                    required: true,
                                                    size: 'small',
                                                    inputProps: {
                                                    style: { fontSize: '.75rem' }
                                                    }
                                                }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                            </Grid>                           
                            
                            <Grid item xs={12} sm={3} sx={{ display: 'flex', gap: 1 }}>
                                <Button
                                    variant="contained"
                                    type='submit'
                                    // onClick={fetchPayoutRecords}
                                    disabled={loading || !isDirty}
                                    startIcon={<Search />}
                                    size="small"
                                >
                                    {loading ? <CircularProgress size={20} color="inherit" /> : 'Search'}
                                </Button>
                                {/* {(searchType === 'booking' || rows.length > 0) && ( */}
                                    <IconButton onClick={handleClear} size="small" title="Clear">
                                        <Clear />
                                    </IconButton>
                                {/* )} */}
                                
                            </Grid>
                        </Grid>
                        

                        
                        {/* <TextField
                        value={quickFilterText}
                        onChange={(event) => setQuickFilterText(event.target.value)}
                        placeholder="Quick Search ..."
                        size="small"
                        fullWidth
                        sx={{
                            '& .MuiOutlinedInput-root': {
                            paddingLeft: '0px',
                            }
                        }}
                        InputProps={{
                            inputProps: {
                            style: {
                                height: '0.6rem',
                                textTransform: 'uppercase',
                                fontSize: 'x-small'
                            },
                            },
                            startAdornment: (
                            <InputAdornment position="start">
                                <IconButton>
                                <Search sx={{fontSize:'x-small'}}/>
                                </IconButton>
                            </InputAdornment>
                            ),
                        }}
                        /> */}
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {rows.length > 0 && (
                        <ExportAll taxData = {rows} startDate={startDate} endDate={endDate} />

                            // <Button
                            //     variant="outlined"
                            //     onClick={exportToExcel}
                            //     startIcon={<Download />}
                            //     size="small"
                            // >
                            //     Export
                            // </Button>
                        )}
                    </Box>
                </Box>
                <DataGrid
                    rows={rows.map((row, index) => ({ ...row, id: `${row?.bookingNumber}-${index}` }))}
                    columns={columns.map((col) => ({
                        ...col,
                        flex: col.flex || 1, // Ensure columns resize dynamically
                        minWidth: col.minWidth || 150, // Set a minimum width to avoid overlap
                    }))}
                    getRowId={(row) => row?.id}
                    rowCount={rows && rows.length > 0 ? rows.length : 0} // Use totalRecords from API response
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    
                    showFirstButton={true}
                    showLastButton={true}

                    disableMultiSort={true}
        
                    loading={loading}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    disableDensitySelector
                    sortingOrder={['asc', 'desc']}
                    slots={{
                        // toolbar: GridToolbar,
                        loadingOverlay: Loading,
                        // Optionally use custom pagination
                        pagination: CustomPagination,
                    }}
                    autoHeight
                    getRowHeight={() => 'auto'}
                    sx={{
                 minWidth: "100%", // Ensures DataGrid expands inside scrollable container
                        "& .MuiDataGrid-root": {
                        overflowX: "auto",
                        },
                  height:'68vh',
                    borderRadius:'0',
                    '& .MuiDataGrid-cell': {
                    border: 1,
                    borderRight: 0,
                    borderTop: 0,
                    borderColor: 'lightgrey',
                    display: 'flex',
                    alignItems: 'center',
                    // justifyContent: 'center',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                    //   borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p:0,
                        minHeight:'0 !important',
                        height:'2rem'
                    },
                    '& .MuiDataGrid-columnHeader': {
                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                    borderBottom: 'none',
                    '&:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 600,
                    color: '#3e3e3e'
                    },
                    '& .MuiDataGrid-row': {
                        '& .MuiDataGrid-cell': {
                            py:1
                        },
                        // Add styles for deleted rows
                        '&.deleted-row': {
                            backgroundColor: '#ffebee !important', // Light red background
                            '&:hover': {
                            backgroundColor: '#ffcdd2 !important', // Darker red on hover
                            }
                        },
                        '& .MuiDataGrid-cell:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child .MuiDataGrid-cell': {
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    },
                    '& .MuiDataGrid-cell:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnSeparator': {
                    display: 'none',
                    },
                }}
                    />
                </Box>
            </Box>
        </Card>
        { finalPayout && finalPayout.length > 0 &&
            <FinalPayout rows={finalPayout} loading={loading} startDate={startDate} endDate={endDate} />
        }
    </>
  )
}

export default ExpertPayout
